import { useRef, useMemo } from "react";
import { AlertService } from "../../../services/Alert";
import useModal from "../../../hooks/useModal";
import { useLocation } from "react-router-dom";
import { APPS } from "../../../constants";

const templateCode = `
<script src="https://voices-dev.github.io/contacto_wa.js"></script>
<script>
    document.addEventListener("DOMContentLoaded", (event) =>  voicesWhatsApp("NUMBER","MESSAGE","TOKEN") )
</script>
`

interface EmbedCodeModalProps {
    state: { show: boolean, link: any};
    onRequestClose: () => void
}
function EmbedCodeModal({ state, onRequestClose }: EmbedCodeModalProps) {


    const modal = useRef<HTMLDivElement>(null);

    const { state: { channels }  } = useLocation()

    useModal(modal, state.show)

    const whatsappStandar = useMemo(() => channels.find( c => c.app.toUpperCase() === APPS.WHATSAPP_STANDAR ), [channels])
    const whatsappBusiness = useMemo(() => channels.find( c => c.app.toUpperCase() === APPS.WHATSAPP_BUSINESS ), [channels])
    
    const code = useMemo(() => {
        if(!state.link) return templateCode;
        
        const number = state.link.app === 'wa-business' ? whatsappBusiness.meta_phone_number: whatsappStandar.number;
        
        return templateCode
            .replace('NUMBER', number)
            .replace('MESSAGE', state.link.message)
            .replace('TOKEN', state.link.token)
        
    }, [state.link])


    const copyToClipboard = async() => {
        await navigator.clipboard.writeText(code);

        AlertService.toastSuccess('Texto copiado', 2000)
    }

    return (
        <div className="modal fade" ref={modal} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content ">
                    <div className="modal-header">
                        <h4 className="modal-title">Insetar botón en mi web</h4>
                        <button type="button" className="btn-close" onClick={onRequestClose}></button>
                    </div>
                    <div className="modal-body">
                        <p>Copie y pegue el siguiente fragmento de código en su sitio web para ayudar a sus clientes a encontrar su canal de comunicación y así enviar el mensaje predeterminado seleccionado.</p>

                        <div className='navbar-voices rounded-1 border p-2 relative'>
                            <button type='button' className='btn btn-ghost-primary btn-lg fix-top-right' onClick={copyToClipboard}><i className="bi bi-files"></i> Copiar</button>
                            <pre className='monospace p-3' >
                                {code}
                            </pre>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default EmbedCodeModal
